import React, { Fragment } from "react";
const LocomotiveHeaderRailCar = ({ year = "", previousNumber = "", carType = "" }) => {
  let cType = carType === "A Car" ? "A - CAR" : carType === "C Car" ? "C - CAR" : "";
  const headerContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    padding: "10px 20px",
    backgroundColor: "#fff",
    fontFamily: "Arial, sans-serif",
    fontSize: "13px",
    color: "#333",
  };

  const leftSectionStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    textAlign: "left",
    marginRight: "20px",
    minWidth: "150px", // Ensure it doesn't get too narrow
  };

  const middleSectionStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1, // Allow this section to grow
    minWidth: "250px", // Minimum width for middle section
    margin: "0 10px",
  };

  const middleTopStyle = {
    fontWeight: "bold",
    fontSize: "10px",
    marginBottom: "5px",
    textTransform: "uppercase",
  };

  const yearStyle = {
    fontSize: "30px",
    fontWeight: "bold",
    color: "#333",
    marginTop: "-5px", // Adjust to visually align with "REPORTING YEAR:"
  };

  const aCarBoxStyle = {
    backgroundColor: "#333", // Dark background as in the image
    color: "#fff",
    fontSize: "24px",
    fontWeight: "bold",
    padding: "5px 20px",
    marginTop: "15px", // Adjust to align vertically
    whiteSpace: "nowrap",
    letterSpacing: "2px", // Slight letter spacing to match
    textShadow: "1px 1px 2px rgba(0,0,0,0.5)", // Subtle shadow for depth
  };

  const locoRecordStyle = {
    fontSize: "14px",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginTop: "10px",
    whiteSpace: "nowrap",
  };

  const rightSectionStyle = {
    flexBasis: "40%", // Take up significant portion of the right
    maxWidth: "400px",
    textAlign: "left",
    fontSize: "10px",
    lineHeight: "1.4",
    marginLeft: "20px",
  };

  const previousNumberContainerStyle = {
    display: "flex",
    alignItems: "center",
    marginTop: "15px",
    width: "100%",
    justifyContent: "center", // Center the input boxes
  };

  const previousNumberLabelStyle = {
    marginRight: "5px",
    whiteSpace: "nowrap",
    fontSize: "10px",
  };

  const numberInputBoxStyle = {
    width: "25px",
    height: "25px",
    border: "1px solid #000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "2px",
    backgroundColor: "#f9f9f9", // Slightly off-white background for input boxes
    fontSize: "14px",
    fontWeight: "bold",
  };

  const checkNewLocoStyle = {
    fontSize: "10px",
    marginTop: "10px",
    textAlign: "center",
    width: "100%",
  };

  return (
    <Fragment>
      <div style={{ ...middleSectionStyle, textAlign: "center" }}>
        <div style={aCarBoxStyle}>{cType}</div>
      </div>
      <div style={headerContainerStyle}>
        <div style={leftSectionStyle}>
          <span>US Department</span>

          <span>Of Transportation</span>

          <strong>Federal Railroad</strong>
          <strong>Administration</strong>
        </div>

        <div style={middleSectionStyle}>
          <div style={middleTopStyle}>REPORTING YEAR:</div>
          <div style={yearStyle}>{year}</div>

          <div style={checkNewLocoStyle}>Check If New Loco.</div>
        </div>

        <div style={{ ...middleSectionStyle }}>
          <div style={previousNumberContainerStyle}>
            <span style={previousNumberLabelStyle}>If Loco. Renumbered</span>
            <span style={{ ...previousNumberLabelStyle, marginRight: "10px" }}>Give Previous # {">"}</span>
            {Array.from(String(previousNumber).padEnd(6, " ")).map((digit, index) => (
              <div key={index} style={numberInputBoxStyle}>
                {digit === " " ? "" : digit}
              </div>
            ))}
          </div>
        </div>

        <div style={rightSectionStyle}>
          <div style={locoRecordStyle}>LOCOMOTIVE INSPECTION AND REPAIR RECORD</div>
          <span>In accordance with the Locomotive Inspection Act, 36 State, 913, as amended and</span>
          <br />
          <span>the regulations issued pursuant to the Act, the parts and appurtenances of the</span>
          <br />
          <span>locomotive unit have been inspected and all defects disclosed by the inspection</span>
          <br />
          <span>have been properly repaired</span>
        </div>
      </div>
    </Fragment>
  );
};

export default LocomotiveHeaderRailCar;



// WEBPACK FOOTER //
// ./src/components/BlueCardReport/BlueCardReportView/BlueCardHeader/BllueCardHeaderRailCar.jsx